"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var theme = require("./theme.scss");
var label_1 = require("@vidazoo/ui/lib/components/label");
var marquee_1 = require("@vidazoo/ui/lib/components/marquee");
exports.default = (function (props) { return (React.createElement("a", { className: theme.app, href: props.manifest.clientUrl, rel: "noopener", target: "_blank" },
    React.createElement("div", { className: theme.icon },
        React.createElement("img", { alt: props.manifest.displayName, src: props.manifest.iconUrl })),
    React.createElement("div", { className: theme.label },
        React.createElement(marquee_1.Marquee, { active: true },
            React.createElement(label_1.Label, { uppercase: false, spacing: 1.5, size: 10 }, props.manifest.displayName))))); });
